import { useNavigate } from 'react-router-dom';
import Table from '../common/Table/Table';

const Columns = [
  { Header: 'Email', accessor: 'email' },
  { Header: 'First Name', accessor: 'firstName' },
  {
    Header: 'Last Name',
    accessor: 'lastName',
  },
];

const SignupCode = ({ signupCode }: { signupCode?: ISignupCode }) => {
  const navigate = useNavigate();
  const data = signupCode?.redemptions || [];
  return (
    <div className="SignupCode">
      <h4>{data.length} Redeemed</h4>
      <Table
        columns={Columns}
        data={data}
        onRowClick={(row) => navigate(`/admin/users/${row._id}`)}
      />
    </div>
  );
};

export default SignupCode;
